import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	moreOptionsSelectedIndicator: {
		id: 'polaris-common.filters.filter-component.select.more-options-selected-indicator',
		defaultMessage: 'and {number} more',
		description: 'Indicator how many more items are selected in the filter dropdown',
	},
});
